import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import './index.css';
import 'antd/dist/antd.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter as Router } from 'react-router-dom';
import {UserContextProvider} from './components/stores/contexts/userContext';
import { AccessContextProvider } from './components/stores/contexts/accessContext';

ReactDOM.render(
  <React.StrictMode>
    <UserContextProvider>
      <AccessContextProvider>
        <Router>
          <App />
        </Router>
      </AccessContextProvider>
    </UserContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
